<div
  [id]="id"
  class="notification-alert madero-style alert alert-{{ type }} {{ cssClass }}"
  [class.notification-alert--with-icon]="title"
  role="alert"
  aria-live="polite"
>
  @if (title) {
    <mat-icon
      class="notification-alert__icon"
      [svgIcon]="icon[type]"
      aria-hidden="true"
    />
  }

  <div class="notification-alert__content">
    <div
      class="notification-alert__title"
      [ngClass]="{ 'title-bold': boldTitle }"
    >
      @if (title) {
        <span>{{ title }}</span>
      }
      @if (showCloseButton()) {
        <div class="tw-flex tw-justify-end">
          <button
            mat-icon-button
            type="button"
            class="close-button"
            aria-label="Dismiss alert"
            (click)="dismissed.emit()"
          >
            <mat-icon svgIcon="close" />
          </button>
        </div>
      }
    </div>
    @if (message) {
      <p class="notification-alert__message">{{ message }}</p>
    }
    <div class="content-wrapper">
      <ng-content></ng-content>
    </div>
  </div>
</div>
